<template>
  <div class="home page-wrapper">
    <div class="banner-wrapper">
      <div class="slide-wrapper" ref="scroll">
        <div class="slide-content">
          <div class="slide-page">
            <img src="../../assets/home_banner.png" />
          </div>
          <div class="slide-page">
            <img src="../../assets/home_banner2.png" />
          </div>
        </div>
      </div>
      <div class="dots-wrapper">
        <span
          @click="goToPage(num - 1)"
          class="dot"
          v-for="num in nums"
          :key="num"
          :class="{'active': currentPageIndex === (num - 1)}"></span>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <el-row class="section1" type="flex">
          <el-col :span="24" :md="{span:8}">
            <div class="section1-about">
              <img class="section1-image" src="../../assets/home_about.png" />
              <img class="section1-image-decoration" src="../../assets/home_about_line.png" />
            </div>
          </el-col>
          <el-col :span="24" :md="{span:16}">
            <p>深圳大于智能有限公司是行业领先的AloT物联网运营服务商，专注于赋能传统照明安防、雷达看护等垂直行业设备厂一站式智能升级。大于智能自主研发架构的、AIMORE AloT云开发平台，面向智慧家用照明、商业照明、智能家居及智能安防等垂直行业，提端到端整体智能化解决方案。核心业务包括企业级云连接、云智能服务，通过接入现有设备将云服务能力赋予终端用户，实现传统制品牌、OEM厂商、消费者等智能化需求。</p>
            <p>AlMORE敏捷物联网平台通过极速物联技术及平台强大的可拓展性、丰富的通用功能组件库，兼容多种物联常用传输协议，最大度降低硬件开发技术门槛及研发成本，助力全球垂直行业用户零风险、免开发、短时间、高标准快速落地AloT产品，行业一站式端解决方案助力客户完成商业模式快速升级，提升产品竞争力与附加值。</p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="section2">
      <div class="container">
        <div class="row">
          <el-row>
            <el-col :span="24" :sm="{span: 12, offset: 6}" :md="{span: 10, offset: 0}" >
              <img src="../../assets/home_detail.png" />
            </el-col>
            <el-col :span="24" :sm="{span: 12, offset: 6}" :md="{span: 10, offset: 4}" >
              <h3>化繁为简</h3>
              <p>技术应该化繁为简。大于智能将家庭住所中各独立的系统集成起来，并通过大于智能客户端实现便捷的监测好人控制。</p>
              <p>利用AIMORE APP可连接您喜爱的所有品牌和现已安装的大于智能产品，包括灯具、音箱系统、智能家电、智能家居等等。</p>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="section3">
          <h3>智能一体化</h3>
          <h4>我们提供全方面立体化的智能服务</h4>
        </div>
      </div>
    </div>

    <div class="section4-w" style="overflow:hidden;">
      <el-row class="section4" :gutter="16">
        <el-col :span="8" :xs="{ span:24 }">
          <img src="../../assets/home_zhineng_yiliao.png" alt="">
          <h4>智能医疗</h4>
        </el-col>
        <el-col :span="8" :xs="{ span:24 }">
          <img src="../../assets/home_quanwu_zhineng.png" alt="">
          <h4>全屋智能</h4>
        </el-col>
        <el-col :span="8" :xs="{ span:24 }">
          <img src="../../assets/home_zhineng_dengpao.png" alt="">
          <h4>智能灯泡</h4>
        </el-col>
      </el-row>
    </div>


    <div class="container">
      <div class="row">
        <div class="section5">
          <h3>我们的服务</h3>
          <h4>五维一体化服务，让产品更懂用户</h4>
        </div>
        <div class="section6">
          <el-row>
            <el-col :span="12" :sm="{span: 8}" :md="{ span: 4}">
              <img src="../../assets/home_xmpg.png" alt="" style="transform:translateX(12px)">
              <h4>项目评估</h4>
              <p>需求沟通、方案设计</p>
              <p>周期评估、成本估算</p>
            </el-col>
            <el-col :span="12" :sm="{span: 8}" :md="{ span: 4, offset: 1}">
              <img src="../../assets/home_sjkf.png" alt="">
              <h4>设计开发</h4>
              <p>外观设计、结构设计</p>
              <p>硬件开发、模具设计</p>
            </el-col>
            <el-col :span="12" :sm="{span: 8}" :md="{ span: 4, offset: 1}">
              <img src="../../assets/home_csyz.png" alt="">
              <h4>测试验证</h4> 
              <p>样品测试、小批量生产</p>
              <p>专业认证、标准制定</p>
            </el-col>
            <el-col :span="12" :sm="{span: 8}" :md="{ span: 4, offset: 1}">
              <img src="../../assets/home_ysfb.png" alt="">
              <h4>验收发布</h4>
              <p>产品验收、资料移交</p>
              <p>合作推广</p>
            </el-col>
            <el-col :span="12" :sm="{span: 8}" :md="{ span: 4, offset: 1}">
              <img src="../../assets/home_shfw.png" alt="">
              <h4>售后服务</h4>
              <p>售后服务、市场反馈</p>
              <p></p>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Slide from '@better-scroll/slide'

BScroll.use(Slide)
// @ is an alias to /src
// import {throttle} from '@/common/index'
export default {
  name: 'Home',
  components: {

  },
  data() {
    return {
      imgHeight: '720px',
      currentPageIndex: 0,
      nums: 2
    }
  },
  created() {
    // this.getHeight_d = throttle(20, this.getHeight)
    // window.addEventListener('resize', this.getHeight_d)
    // this.getHeight()
  },
  mounted() {
    this.initScroll()
  },
  methods: {
    getHeight() {
      this.imgHeight = (window.innerWidth / 1920 * 720).toFixed(0) + 'px'
    },
    async initScroll() {
      await this.$nextTick()
      const slide = new BScroll(this.$refs.scroll, {
        scrollX: true,
        scrollY: false,
        slide: true,
        momentum: false,
        bounce: false,
        probeType: 3
      })
      this.slide = slide
      this.slide.on('slideWillChange', (page) => {
        this.currentPageIndex = page.pageX
      })
    },
    goToPage(idx) {
      this.slide.goToPage(idx, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: var(--font-large-size);
  font-weight: normal;
  text-align: center;
}

h4 {
  font-size: var(--font-medium-size);
  font-weight: normal;
  text-align: center;
}

.section1 {
  margin: var(--margin-normal) 0;
  align-items: stretch;
  flex-wrap: wrap;
  .el-col:first-child {
    display: flex;
    align-items: flex-end;
  }
  .section1-about {
    position: relative;
    margin-bottom: 12px;
    .section1-image-decoration {
      position: absolute;
      left: 75px;
      bottom: 0;
    }
  }

  p {
    line-height: 2;
    font-size: var(--font-normal-size);
  }
}

.section2 {
  background-color: #ECECEC;
  padding: var(--margin-max-max) 0;
  position: relative;

  .el-col {
    height: 100%;
    position: relative;

    img {
      width: 100%;
    }
  }

  .el-col:last-child {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  h3 {
    font-size: var(--font-large-size);
    font-weight: normal;
    text-align: center;
    margin-top: var(--margin-large);
    margin-bottom: var(--margin-large);
  }

  p {
    line-height: 2;
    font-size: var(--font-normal-size);
  }
}

.section3, .section5 {
  h3 {
    margin-top: var(--margin-normal);
  }
  h4 {
    margin-top: var(--font-medium-size);
  }
}

.section4 {
  margin-top: var(--margin-small);

  .el-col {
    margin-top: var(--margin-min);
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    h4 {
      position: absolute;
      bottom: 0;
      left: 8px;
      height: 20.3%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100% - 16px);
      font-size: var(--font-medium-size);
    }
  }
}

.section6 {
  margin: var(--margin-normal) 0 var(--margin-max-max);

  .el-col {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    height: 240px;

    h4 {
      font-size: 20px;
      margin-top: 12px;
    }

    p {
      width: 100%;
      text-align: center;
      margin-top: 8px;
      font-size: var(--font-normal-size);
      color: rgba(0, 0, 0, .56);
    }
  }
}

.banner-wrapper {
  position: relative;
  margin: 0 auto;
  .slide-wrapper {
    min-height: 1px;
    overflow: hidden;
    .slide-content {
      white-space: nowrap;
      font-size: 0;
      .slide-page {
        display: inline-block;
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }

  .dots-wrapper {
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    .dot {
      display: inline-block;
      margin: 0 4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #EEE;
      transition: all .3s ease;
      cursor: pointer;
      &.active {
        width: 20px;
        border-radius: 5px;
      }
    }
  }
}

@media screen and (max-width: 991px) {
  .section6 {
    img {
      height: 67px;
    }
  }
}
</style>
